/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum EmotionSupplierType {
  None = 'None',
  Wellcrowd = 'Wellcrowd'
}
